module.exports = __webpack_public_path__ + "img/UGAlogo_TopShield_1C_MARCM.6d67c376.png";